/**
 * 胎号的表单验证处理
 * @author zjs
 * @time 2017-09-21
 */
export default {

    methods: {
        /**
         * 验证货品信息
         * @param  {[Array]} arr [货品列表]
         */
        validateProduct (arr) {
            let msg = '' // 提示的信息
            let index = -1 // 记录有问题的行
            for (let i in arr) {
                let row = arr[i]
                let bool = false
                // 判断是否选择货品
                if (!row.customer || !row.customer.customer_account) {
                    msg += '"客户编码"'
                    bool = true
                }
                if (!row.customer || !row.customer.customer_name) {
                    msg += '"客户名称"'
                    bool = true
                }
                if (!row.customer || !row.customer.customer_id) {
                    msg += '"客户信息"'
                    bool = true
                }
                if (!row.work_time || row.work_time.length < 1) {
                    if (bool) {
                        msg += '\n、\n'
                    }
                    msg += '"单据时间"'
                }
                if (!row.product || !row.product.product_id) {
                    msg += '"往来项目"'
                    bool = true
                }
                if (!row.amount) {
                    msg += '"金额"'
                    bool = true
                }
                if (msg.length > 0) {
                    index = i
                    break;
                }
            }
            if (index >= 0) {
                msg = '第' + parseInt(parseInt(index) + 1) + '行还未选择\n' + msg
            }
            return msg
        }
    }
}